import React from 'react';
import {BaseProps} from "../../../infrastructure/models/props/base-props";
import classnames from "classnames";
import styles from "./arrow.module.scss";

export class RightArrowComponentProps extends BaseProps {
  className: String;
}

export const RightArrow = (props: RightArrowComponentProps) => {
  const className = classnames(props.className, styles.arrow);

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="11" height="18" viewBox="0 0 11 18" className={className}>
      <path fillRule="evenodd" d="M10.545 9.009L2.06 17.494.845 16.28l7.273-7.273L.83 1.718 2.042.506l8.503 8.503z"/>
    </svg>
  )
}
